import { useTranslation } from "react-i18next";
import { useJobRoleDetailsContext } from "../../components/JobRoleDetailsTree/JobRoleDetails";
import { Row } from "react-bootstrap";

export default function TechAreaInterestInterviewHelper({
  searchObject,
  onChange,
  candidateInterestTechAreas,
  candidateInterestTechRoles
}) {
  const { t } = useTranslation();
  const { setHelperOpen } = useJobRoleDetailsContext();

  return (
    <Row>
      <div className="col-md-7">
        <label>{t("Tech Area Interest")}{" "}
          <a
            className="col text-end"
            href="#"
            onClick={() => setHelperOpen(true)}
            style={{marginLeft:"35px"}}
          >
            {t("View Categorization")}
          </a>
        </label>
        <select
          className="form-select"
          name="candidateInterestTechAreaId"
          id="candidateInterestTechAreaId"
          onChange={onChange}
          value={searchObject.candidateInterestTechAreaId || ""}
        >
            <option key={0} value="" selected>
                {t("Select Professional Category Interest...")}
            </option>
            {candidateInterestTechAreas?.map((candidateInterestTechArea) => (
            <option
                key={candidateInterestTechArea.id}
                value={candidateInterestTechArea.id}
            >
                {t(candidateInterestTechArea.description)}
            </option>
            ))}
        </select>
      </div>
      <div className="col-md-5">
        <label>{t("Tech Role Interest")}</label>
        <select
          className="form-select"
          name="candidateInterestTechRoleId"
          id="candidateInterestTechRoleId"
          onChange={onChange}
          value={searchObject.candidateInterestTechRoleId || ""}
        >
            <option key={0} value="" selected>
                {t("Select Role Interest...")}
            </option>
            {candidateInterestTechRoles?.map((candidateInterestTechRole) => (
            <option
                key={candidateInterestTechRole.id}
                value={candidateInterestTechRole.id}
            >
                {t(candidateInterestTechRole.description)}
            </option>
            ))}
        </select>
      </div>
    </Row>
  );
}
